<template>
    <div v-if="name || address">
      <div class="name-container" v-if="name">
          <img alt="" src="~/assets/images/hp-logomark-rgb.png" v-if="result.hpmgPractitioner" />
          <hp5-link-text-tertiary>
            <a :data-card-rank="rank" :href="url"> {{ name}} </a>
          </hp5-link-text-tertiary>
      </div>
      <hp5-spacing-vertical xs="xs"></hp5-spacing-vertical>
      <div class="address">
        <hp5-link-text-tertiary>
          <hp5-icon size="xs" name="system-location-pin" style="fill: var(--color-link-base);"/>
          <a :data-card-rank="rank" :href="url"> {{ address }} </a>
        </hp5-link-text-tertiary>
      </div>
      <ResultsBaseDistance :result="result" />
    </div>
</template>

<script setup>

    const props = defineProps({
        result: Object,
        rank: Number
    })

    const { context } = useFCPModel()
    const { buildUrl } = useUrls(context.value)

    const address = computed(() => {
        const { locationAddress } = props.result
        return locationAddress ? `${locationAddress?.street1} ${locationAddress?.city} ${locationAddress?.state}, ${locationAddress?.zip}` : null
    })

    const name = computed(() => props.result.locationName)
    const url = computed(() => props.result.locationId ? buildUrl('/fcp/location-detail/', { locationId: props.result.locationId }) : null )

</script>
  
<style lang="scss" scoped>
  span {
    display: inline;
  }
  
  .name-container {
    display: flex;
    align-items: center;
  }
  
  a,
  img {
    display: inline-block;
  }
  
  @media only screen and (max-width: 480px) {
    a {
      display: inline;
    }
  }
  
  img {
    height: var(--text-body-line-height-sm);
    margin-right: var(--spacing-xxs);
  }
  hp5-link-text-tertiary .hp-link-text-tertiary {
    font-size: var(--text-heading-pixels-xxs);
  }
</style>